import {
    sumBy as _sumBy,
} from '@lodash';
import clientStorage from '@utils/storage/ClientStorage';
import DateUtils from '@utils/date/DateUtils';
import config from '@config';
import User from './User';

export function shouldChooseGdprConsent(user: User): boolean {
    return isLegacyUser(user) && !hasGdprConsent(user);
}

export function hasGdprConsent(user: User): boolean {
    return user.acceptsGeneralPrivacy && user.acceptsCustomPrivacy;
}

export function isLegacyUser(user: User): boolean {
    return DateUtils.isBefore(user.lastModified, config.launchDate);
}

export function getBalance(user: User): number | null {
    if (!user.balance) {
        return null;
    }

    return user.balance.amount;
}

export function getBalanceWithBonus(user: User): number | null {
    if (!user.balance) {
        return null;
    }

    return user.balance.amount + getBonus(user)!;
}

export function getBonus(user: User): number | null {
    if (!user.balance) {
        return null;
    }
    return _sumBy(user.balance.bonus, 'amount');
}

export function setIdCardVerificationPending(user: User): void {
    clientStorage.set(`user:${user.userId}:idCardLastUpload`, DateUtils.toString(new Date()));
}

export function  deleteIdCardVerificationPending(user: User): void {
    clientStorage.remove(`user:${user.userId}:idCardLastUpload`);
}

export function isIdCardVerificationPending(
    user: User,
    pendingHours = config.app.user.idCardVerification.pendingHours
): boolean {
    const lastUploadDate = clientStorage.get(`user:${user.userId}:idCardLastUpload`);

    if (!lastUploadDate) {
        return false;
    }

    const pendingEndDate = DateUtils.addHours(pendingHours, DateUtils.toDate(lastUploadDate));
    return DateUtils.isBefore(new Date(), pendingEndDate);
}

export function isIdCardVerificationJustBeenApproved(user: User): boolean {
    return user && user.isVerifiedIdCard && isIdCardVerificationPending(user);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/user/UserDataService.ts